
	import Component from 'vue-class-component'
	import moduleStore from './store/CourseDetail';
	import Vue from 'vue';
	import PageState from './store/state';


	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class CourseDetailPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
		}
		mounted(moduleData:IinjectDatas){
			/*this.$http("getDataList",{}).then((response:any)=>{
				console.log(response)
			}).catch((ex:any)=>{
				console.log(ex)
			})*/
	
			this.state.title="这是更改后的title"
			this.state.self = this;
		}
		readRule() {
			//跳转到规则页
			this.$router.push({ path: '/CourseRule', query: { ww_token: '111' } })
		}
		enjoy(){
			//获取手机号
			// this.$sendMessage({buttonType:'getUserPhone'})
			
		}
		buyCourse(){
			let  ua = navigator.userAgent.toLowerCase() 
			let matchs = ua.match(/linux/i);
			console.log('---matchs',matchs);
			if(  matchs && matchs[0] == "micromessenger" ) {
				//ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
				window.taroRawSdk.miniProgram.getEnv((res)=>{
					if (res.miniprogram) {
						console.log("在小程序里")
						let params = "?a=111222"
						window.taroRawSdk.miniProgram.navigateTo({
							url:"../course-detail/course-detail"+params
						})
					} else {
						console.log("不在小程序里")
					}
				})
			}else {
				console.log('不在微信里')
			}
		}
	}